import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import imageOne from "../../assets/images/gifts-image-one.svg";
import imageTwo from "../../assets/images/gifts-image-two.svg";
import imageThree from "../../assets/images/gifts-image-three.svg";
import imageFour from "../../assets/images/gifts-image-four.svg";
import { useEffect } from "react";
import { viewAllGifts } from "../../utils/translations";
import "./viewAllGifts.css";

export default function ViewAllGifts() {
  const newGifts = [imageOne, imageTwo, imageThree, imageFour];
  const oldGifts = [imageThree, imageFour, imageOne, imageTwo];

  const navigate = useNavigate();
  const { language } = useLanguage();

  const GiftSection = ({ title, images }) => (
    <div className={`viewAllGifts-section`}>
      <h3 className={`viewAllGifts-giftsTitle`}>
        {viewAllGifts[language][title]}
      </h3>
      <div className={`viewAllGifts-giftsContainer`}>
        <motion.div
          className="viewAllGifts-giftsList"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
        >
          {images.map((image, index) => (
            <motion.img
              key={index}
              src={image}
              alt={`gift-${index}`}
              className="viewAllGifts-image"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 0.5, delay: index * 0.2 } }}
            />
          ))}
        </motion.div>
      </div>
    </div>
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`viewAllGifts-pageContainer ${language === "ar" ? "rtl" : ""} ${language === "ar" ? "arab" : ""}`}>
      <h2 className="viewAllGifts-pageTitle">{viewAllGifts[language].pageTitle}</h2>

      <GiftSection title="newGifts" images={newGifts} />
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
        <hr style={{ width: "50%", borderTop: "1px solid var(--secondary-color)" }} />
      </div>
      <GiftSection title="oldGifts" images={oldGifts} />
      <div className="viewAllGifts-buttonDiv">
        <button className={`viewAllGifts-backButton ${language === "ar" ? "right-button" : ""}`} onClick={() => navigate("/")}>
          {viewAllGifts[language].backButton}
        </button>
      </div>
    </div>
  );
}

